import { DefaultTheme as NavigationDefaultTheme } from '@react-navigation/native';
import { Platform } from 'react-native';
import { adaptNavigationTheme } from 'react-native-paper';
import { theme } from './theme';
import { typeScale } from './typography';
const { LightTheme } = adaptNavigationTheme({
    reactNavigationLight: NavigationDefaultTheme,
    materialLight: theme,
});
/**
 * Shared native-stack header title styling (nav titles across the app).
 * Native uses the Abbi Theme `navTitle` role; web admin keeps its 22pt title.
 */
export const stackHeaderTitleStyle = {
    fontSize: Platform.OS === 'web' ? 22 : typeScale.navTitle.fontSize,
    fontWeight: typeScale.navTitle.fontWeight,
    color: theme.colors.textPrimary,
};
/** React Navigation theme aligned with Paper / AbbisWay `theme`. */
export const navigationLightTheme = {
    ...LightTheme,
    colors: {
        ...LightTheme.colors,
        // Native stack headers use `card`; keep them continuous with the warm off-white screen.
        card: theme.colors.backgroundScreen,
        background: theme.colors.backgroundScreen,
        // Back chevrons / header buttons: identity accent (crimson on native).
        primary: theme.colors.accent,
        notification: theme.colors.accent,
    },
};
